<template>
	<div class="breadcrumb-line">
		<span class="label">当前位置:</span>
		<el-breadcrumb class="app-breadcrumb" separator=">">
			<transition-group name="breadcrumb">
				<el-breadcrumb-item
					v-for="(item, index) in levelList"
					:key="'a' + index"
				>
					<span>{{ item.meta.title }}</span>
				</el-breadcrumb-item>
			</transition-group>
		</el-breadcrumb>
	</div>
</template>

<script>
export default {
	data() {
		return {
			levelList: []
		}
	},
	watch: {
		$route() {
			this.getBreadcrumb()
			document.getElementById('main').scrollTop = 0
		}
	},
	computed: {},
	created() {
		this.getBreadcrumb()
	},
	methods: {
		getBreadcrumb() {
			let matched = this.$route.matched
			const list = matched.filter(item => item.path)
			this.$store.commit(
				'setRoutePath',
				list[list.length - 1].meta.parentPath || list[list.length - 1].path
			)
			this.levelList = list
		},
		handleLink(item) {
			const { redirect, path } = item
			if (redirect) {
				this.$router.push(redirect)
				return
			}
			this.$router.push(this.pathCompile(path))
		}
	}
}
</script>

<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.breadcrumb-line {
	height: 50px;
	display: flex;
	align-items: center;
	.label {
		font-size: 14px;
	}
	.app-breadcrumb.el-breadcrumb {
		font-size: 14px;
		margin-left: 10px;
		.no-redirect {
			color: #97a8be;
			cursor: text;
		}
	}
}
</style>
